module.exports = __webpack_public_path__ + "static/media/q8.ab9dabca.png";